import { computed, type Ref, ref } from 'vue';

const LAST_VIEWED_UUID_KEY = 'insightLastViewedUuid';

// 呼び出しごとの ref だと、「今日」タブで既読にしてもサイドバーのバッジ側に伝わらないため共有する。
const lastViewedUuid = ref<string | null>(null);

export const useInsightViewedTracking = (
  insightUuid: Ref<string | null | undefined>,
) => {
  // 値の正は localStorage。テストや Storybook が localStorage を消したときに、共有 ref へ古い値を残さない。
  lastViewedUuid.value = localStorage.getItem(LAST_VIEWED_UUID_KEY);

  const isViewed = computed(() => {
    const current = insightUuid.value;
    if (!current) return false;
    return lastViewedUuid.value === current;
  });

  const markAsViewed = () => {
    const current = insightUuid.value;
    if (!current) return;
    localStorage.setItem(LAST_VIEWED_UUID_KEY, current);
    lastViewedUuid.value = current;
  };

  return { isViewed, markAsViewed };
};
